

const getPublicSurveyUrl = (surveyId: string): string => window.location.origin + '/TakeSurvey?survey_id=' + surveyId;
const getPublicPollUrl = (surveyId: string): string => window.location.origin + '/TakePoll?id=' + surveyId;


export {
    getPublicSurveyUrl,
    getPublicPollUrl
}